import Vue from 'vue'
import App from './App.vue'
import { MdContent, MdField, MdButton, MdProgress } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.config.productionTip = false

Vue.use(MdContent);
Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdProgress);

new Vue({
  render: h => h(App),
}).$mount('#app')
